<template>
  <div>
    <div class="mediaContainer"
    :class="{
      'is-disabled': !isPlayEnabled,
      'is-playing': isPlayingVideo,
      'has-thumbnail' : hasThumbnail
      }">
      <div v-if="videoOptions.title" class="mediaMeta">
        <h2 class="mediaMeta__title">{{ videoOptions.title }}</h2>
      </div>
      <div v-if="videoOptions.size && !isStartedVideo" class="mediaSize">
        <span>SAMPLE&nbsp;{{ videoOptions.size | formatToMMSS }}</span>
      </div>
      <video-player
      ref="videoPlayer"
      :class="{tokutenKantei: ( +targetItemsId === 90000 )}"
      :width="width"
      :height="height"
      :options="videoOptions"
      @play="onPlayerPlay($event)"
      @pause="onPlayerPause($event)"
      @ended="onPlayerEnded()"
      ></video-player>
    </div>
  </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player'
export default {
  name: 'store-video-player',
  components: {
    videoPlayer
  },
  props: {
    options: Object,
    width: Number,
    height: Number,
    count: {
      type: Number,
      default: 0
    },
    hasThumbnail: { type: Boolean, default: false },
    gaCateg: {
      type: String,
      default: 'Videos'
    },
    gaAction: {
      type: String,
      default: 'Play'
    },
    gaLabel: {
      type: String,
      default: '動画再生'
    },
    disablePlaycountApi: {
      type: Boolean,
      default: false
    },
    targetItemsId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      hasPlayedVideo: false,
      isPlayingVideo: false,
      isStartedVideo: false
    }
  },
  watch: {
    options: {
      handler() {
        this.player.load()
      },
      deep: true
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    },
    videoOptions() {
      return Object.assign(
        {
          start: 0,
          playsinline: false,
          language: 'ja',
          fluid: true
        },
        this.options
      )
    },
    targetHeight(){
      if(this.targetItemsId === 90000){
        return +this.height / 2
      }else{
        return this.height
      }
    },
    hasPlayLimit() {
      return typeof this.limit === 'Number'
    },
    isPlayEnabled() {
      if (typeof this.limit === 'undefined') {
        return true
      }
      return this.limit > this.count
    }
  },
  methods: {
    getMoviesKey() {
      const paths = window.location.pathname.split('/')
      return paths[paths.length - 1]
    },
    onPlayerPlay($event) {
      this.isPlayingVideo = true
      this.isStartedVideo = true

      if (!this.hasPlayedVideo) {
        this.hasPlayedVideo = true
        // gaに再生イベントを送信する
        const gaSendOpt = {
          event_category: this.gaCateg,
          event_label: this.gaLabel,
          id: this.getMoviesKey()
        }
        window.gtag('event', this.gaAction, gaSendOpt)
        if(!this.disablePlaycountApi) {
          // 再生数カウントAPIを叩く
          axios
            .get(`/api/movie/count?key=${this.getMoviesKey()}`)
            .then(result => {})
        }
      }
      this.$emit('play', $event)
    },
    onPlayerPause($event) {
      this.isPlayingVideo = false
      this.$emit('pause', $event)
    },
    onPlayerEnded() {
      this.isPlayingVideo = false
      this.$emit('ended')
    }
  },
  mounted() {
    // gaに再生上限イベントを送信する
    if (!this.isPlayEnabled) {
      // gaに再生イベントを送信する
      window.gtag('event', 'Sorry', {
        event_category: 'Videos',
        event_label: '動画再生上限',
        id: this.getMoviesKey()
      })
    }
  }
}</script>

<style lang="scss">
.mediaContainer {
  margin-left: -16px;
  margin-right: -16px;
  position: relative;

  &.has-thumbnail {
    .vjs-poster {
    }
  }

  .video-player {
    background: #000;
    &.tokutenKantei {
      .video-js{
        padding-top: 88.8%;
        .vjs-tech {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          margin: auto;
          width: 50%;
        }
      }
    }
  }
  .video-js {
    margin: auto;
    max-width: 100%;
  }
  .vjs-big-play-button,
  .video-js:hover .vjs-big-play-button {
    height: 48px;
    width: 48px;
    margin-top: -24px;
    margin-left: -24px;
    line-height: 44px;
    border-radius: 24px;
    top: 50%;
    left: 50%;
    border-color: transparent;
    background: rgba(255,255,255,.8);
    left: 50%;
    outline: 0;
    .vjs-icon-placeholder {
      color: #1B1761;
      font-size: 44px;
    }
  }
  .video-js:hover .vjs-big-play-button,
  .vjs-big-play-button:hover {
    background: #FFF;
  }
  .vjs-poster {
    background-size: cover;
  }
  .mediaMeta {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    background: linear-gradient(0deg, rgba(0,0,0,0) 0%, rgba(0,0,0,.7) 80%, rgba(0,0,0,.7) 100%);
    padding: 8px 8px 24px;
    color: #FFF;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, .5);
    &__title {
      margin: 0;
      text-align: left;
      font-size: 12px;
      font-weight: 500;
    }
  }
  .mediaSize {
    color: white;
    font-size: 14px;
    line-height: 14px;
    background: #ed1e79;
    position: absolute;
    right: 5px;
    bottom: 5px;
    z-index: 2;
    border-radius: 8px;
    padding: 8px;
    display: flex;

    &:after {
      content: '';
      width: 14px;
      height: 14px;
      background: url('/static/img/common/play_pink.png');
      background-size: 100%;
      background-position: center;
      background-repeat: no-repeat;
      position: relative;
      display: block;
      margin-left: 4px;
    }
  }
  &.is-playing {
    .mediaMeta {
      display: none;
    }
    .mediaSize {
      display: none;
    }
  }

  // Safari対応
  iframe {
    border: none;
  }
}

.videoInformation {
  padding: 12px 16px;
  color: #FFF;
  font-size: 12px;
  position: absolute;
  background: rgba(0, 0, 0, .7);
  left: 0;
  right: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/StoreVideoPlayer.vue